module.exports = __webpack_public_path__ + "assets/img/146503.2d088a63.png";